import React, { ReactNode } from "react";
import "./LandingPage.scss";
import {
  AbemBaseProps,
  Icon,
  IconProps,
  themeColors,
  useAbem,
} from "@saif/core";
import { Container } from "@saif/container";
import { Heading, HeadingProps, Section } from "@saif/heading";

interface LandingPageProps extends AbemBaseProps {
  iconProps?: IconProps;
  headingProps: Omit<HeadingProps, "className">;
  description?: ReactNode;
  subtitleProps?: Omit<HeadingProps, "className">;
}

export const LandingPage = (props: LandingPageProps) => {
  const { iconProps, headingProps, description, subtitleProps } = props;

  const classes = useAbem<LandingPageProps>({
    atomicLevel: "organisms",
    block: "landingPage",
    props,
  });

  return (
    <Container className={classes.element("container")}>
      <Section className={classes.element("section")}>
        {iconProps && (
          <div className={classes.element("icon-wrapper")}>
            <Icon color={themeColors.primary} {...iconProps} />
          </div>
        )}
        <Heading
          className={classes.element("heading")}
          size="xl"
          {...headingProps}
        />
        {subtitleProps && <Heading offset={1} {...subtitleProps} className={classes.element("subtitle")} />}
        <div className={classes.element("description")}>{description}</div>
      </Section>
    </Container>
  );
};
